function initializeSlickSlider() {
  const $slider = $('.icon-text-has-mobile-slider');

  if (window.innerWidth < 990) {
    if (!$slider.hasClass('slick-initialized')) {
      $slider.slick({
        slidesToShow: 1,
        slidesToScroll: 1,
        autoplay: false,
        arrows: true,
        dots: true,
        adaptiveHeight: true,
        responsive: [
          {
            breakpoint: 768,
            settings: {
              slidesToShow: 1,
              slidesToScroll: 1
            }
          }
        ]
      });
    }
  } else {
    if ($slider.hasClass('slick-initialized')) {
      $slider.slick('unslick');
    }
  }
}

function initializeTrustedBySlider() {
  const $slider = $('.custom-collection-trusted-by-sec');

  if (window.innerWidth < 990) {
    if (!$slider.hasClass('slick-initialized')) {
      $slider.slick({
        slidesToShow: 3.5,
        slidesToScroll: 1,
        autoplay: false,
        arrows: true,
        dots: true,
        infinite: false,
        adaptiveHeight: true,
        responsive: [
          {
            breakpoint: 768,
            settings: {
              slidesToShow: 2.5,
              slidesToScroll: 1
            }
          }
        ]
      });
    }
  } else {
    if ($slider.hasClass('slick-initialized')) {
      $slider.slick('unslick');
    }
  }
}

function initializeTrustedByHomeSlider() {
  const $slider = $('.custom-trusted-by-sec');

  if (window.innerWidth < 990) {
    if (!$slider.hasClass('slick-initialized')) {
      $slider.slick({
        slidesToShow: 3.5,
        slidesToScroll: 1,
        autoplay: false,
        arrows: true,
        dots: true,
        infinite: false,
        adaptiveHeight: true,
        responsive: [
          {
            breakpoint: 768,
            settings: {
              slidesToShow: 2.5,
              slidesToScroll: 1
            }
          }
        ]
      });
    }
  } else {
    if ($slider.hasClass('slick-initialized')) {
      $slider.slick('unslick');
    }
  }
}

function initializeAllSliders() {
  initializeSlickSlider();
  initializeTrustedBySlider();
  initializeTrustedByHomeSlider();
}

function debounce(func, wait) {
  let timeout;
  return function() {
    const context = this, args = arguments;
    clearTimeout(timeout);
    timeout = setTimeout(function() {
      func.apply(context, args);
    }, wait);
  };
}

$(document).ready(function () {
  initializeAllSliders();
});

$(document).on('shopify:section:load', function () {
  initializeAllSliders();
});

$(window).on('resize', debounce(function () {
  initializeAllSliders();
}, 200));

// get offer popup js code 
// document.addEventListener('DOMContentLoaded', function() {
//   const offerBtn = document.getElementById('getOfferBtn');
//   const offerModal = document.getElementById('offerModal');
//   const closeModal = document.getElementById('closeModal');

//   if (offerBtn && offerModal && closeModal) {
//     offerBtn.addEventListener('click', function(event) {
//       event.preventDefault();
//       offerModal.style.display = 'flex';
//       document.body.classList.add('get-offer-popup');
//       document.body.style.overflow = 'hidden';
//     });

//     window.addEventListener('click', function(event) {
//       if (event.target === offerModal) {
//         offerModal.style.display = 'none';
//         document.body.classList.remove('get-offer-popup');
//         document.body.style.overflow = '';
//       }
//     });

//     closeModal.addEventListener('click', function() {
//       offerModal.style.display = 'none';
//       document.body.classList.remove('get-offer-popup');
//       document.body.style.overflow = '';
//     });
//   }
// });

document.addEventListener('DOMContentLoaded', function() {
  const offerBtn = document.getElementById('getOfferBtn');
  const offerModal = document.getElementById('offerModal');
  const closeModal = document.querySelector('.close-modal-pdp');

  if (offerBtn && offerModal && closeModal) {
    function openPopup() {
      offerModal.style.display = 'flex';
      document.body.classList.add('get-offer-popup');
      document.body.style.overflow = 'hidden';
    }

    function closePopup() {
      offerModal.style.display = 'none';
      document.body.classList.remove('get-offer-popup');
      document.body.style.overflow = '';
    }

    offerBtn.addEventListener('click', function(event) {
      event.preventDefault();
      openPopup();
    });

    closeModal.addEventListener('click', closePopup);

    window.addEventListener('click', function(event) {
      if (event.target === offerModal) {
        closePopup();
      }
    });
  }
});



// global get offer popup js code 

// document.addEventListener('DOMContentLoaded', function() {
//   const offerButton = document.querySelector('.global-get-offer-main');
//   const offerButtonMobile = document.querySelector('.global-lightbox-mob .global-get-offer-mob');
//   const popupWrapper = document.querySelector('.global-popup-wrapper');
//   const primaryPopup = document.querySelector('.global-popup-primary');
//   const secondaryPopup = document.querySelector('.global-popup-secondary');
//   const closeModalPrimary = document.getElementById('closeModal');
//   const closeModalSecondary = document.getElementById('closeModalSecondary');
//   const buttonLabels = document.querySelectorAll('.global-popup-button-label');

//   function showPopup() {
//     if (popupWrapper) {
//       popupWrapper.style.display = 'flex';
//       document.body.classList.add('global-lightbox-open');
//       document.body.style.overflow = 'hidden';
//     }
//   }

//   function hidePopup() {
//     if (popupWrapper) {
//       popupWrapper.style.display = 'none';
//       document.body.classList.remove('global-lightbox-open');
//       document.body.style.overflow = '';
//     }
//   }

//   function openPrimaryPopup() {
//     showPopup();
//     if (primaryPopup && secondaryPopup) {
//       primaryPopup.style.display = 'flex';
//       secondaryPopup.style.display = 'none';
//     }
//   }

//   if (window.location.pathname === "/" && !localStorage.getItem('discoveryPopupShown')) {
//     openPrimaryPopup();
//     localStorage.setItem('discoveryPopupShown', 'true');
//   }

//   if (offerButton) {
//     offerButton.addEventListener('click', function(event) {
//       event.preventDefault();
//       openPrimaryPopup();
//     });
//   }

//   if (offerButtonMobile) {
//     offerButtonMobile.addEventListener('click', function(event) {
//       event.preventDefault();
//       openPrimaryPopup();
//     });
//   }

//   if (closeModalPrimary) {
//     closeModalPrimary.addEventListener('click', hidePopup);
//   }

//   if (closeModalSecondary) {
//     closeModalSecondary.addEventListener('click', hidePopup);
//   }

//   window.addEventListener('click', function(event) {
//     if (event.target === popupWrapper) {
//       hidePopup();
//       // openPrimaryPopup();
//     }
//   });
//   buttonLabels.forEach(function(button) {
//     button.addEventListener('click', function() {
//       if (primaryPopup && secondaryPopup) {
//         primaryPopup.style.display = 'none';
//         secondaryPopup.style.display = 'flex';
//       }
//     });
//   });
// });

// Tracking event code for global popup 

// document.addEventListener("DOMContentLoaded", function() {

//   function trackButton(id, eventName, data = {}) {
//     const btn = document.getElementById(id);
//     if (!btn) return;

//     btn.addEventListener("click", function(e) {
//       e.preventDefault();

//       // Shopify Analytics
//       Shopify.analytics.publish(eventName, data);

//       // Optional: push to GTM dataLayer
//       window.dataLayer = window.dataLayer || [];
//       window.dataLayer.push(Object.assign({ event: eventName }, data));

//       // Redirect
//       setTimeout(() => { window.location.href = this.href }, 200);
//     });
//   }

  // Track each button
//   trackButton("global-popup-private", "user_segment_private");
//   trackButton("global-popup-biz-small", "generate_lead", { value: 1, currency: "NOK" });
//   trackButton("global-popup-biz-medium", "hp_prospect_identified", { value: 10, currency: "NOK" });
//   trackButton("global-popup-biz-large", "generate_lead", { value: 1, currency: "NOK" });
//   trackButton("forBusinessBtn", "conversion_intent_b2b", { value: 5, currency: "NOK" });

// });

